import React from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Box, Typography, useMediaQuery } from "@mui/material";

//react-slick-neo
import Slider from "react-slick";

//components
import TestimonyCard from "./TestimonyCard";

//img
import LeftArrow from "../../img/LeftArrow.svg";
import RightArrow from "../../img/RightArrow.svg";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  container: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
    mt: { xs: "93px" },
  },
  title: {
    color: theme.palette.red.main,
    fontSize: { xs: "14px" },
    letterSpacing: { xs: "1.4px" },
    fontFamily: theme.typography.montserrat.semibold,
  },
  span: {
    fontWeight: "bold",
  },
  subtitle: {
    mt: { xs: "24px" },
    maxWidth: { xs: "300px", md: "700px", lg: "700px", xl: "700px" },
    height: { xs: "160px", md: "auto" },
    fontFamily: theme.typography.montserrat.light,
    fontSize: { xs: "32px", md: "43px", lg: "54px", xl: "65px" },
    lineHeight: { xs: "38px", md: "45px", lg: "54px", xl: "65px" },
    textAlign: { xs: "center" },
    color: theme.palette.blue.main,
  },
  name: {
    mt: { xs: "17.6px" },
    fontSize: { xs: "30px" },
    lineHeight: { xs: "36px" },
    textAlign: { xs: "center" },
    fontFamily: theme.typography.montserrat.bold,
    color: theme.palette.blue.main,
  },
  testimony: {
    mt: { xs: "26.3px" },
    fontSize: { xs: "22px" },
    lineHeight: { xs: "33px" },
    textAlign: { xs: "center" },
    fontFamily: theme.typography.anaHeim.regular,
    color: theme.palette.blue.tertiary,
    width: { xs: "225px" },
  },
  logo: {
    width: "117px",
    height: "50px",
    margin: "10px auto 20px auto",
  },
  slider: {
    display: "flex",
    width: "295px",
    justifyContent: "center",
    alignItems: "center",
    marginTop: isMobile ? "auto" : "130px",
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    height: 0,
    backgroundColor: theme.palette.red.main,
  },
  titleContainer: {
    display: { md: "flex" },
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
  },
  sliderContainerDesktop: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  sliderDesktop: {
    marginTop: "110px",
    width: "95%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "255px",
  },
});

function Arrow(props) {
  const theme = useTheme();
  const classes = useStyles(theme);
  let className = props.type === "next" ? "nextArrow" : "prevArrow";
  className += " arrow";

  const char =
    props.type === "next" ? (
      <img
        src={RightArrow}
        alt="flecha"
        style={{
          ...classes.arrow,
          marginLeft: "15px",
        }}
      />
    ) : (
      <img
        alt="flecha"
        src={LeftArrow}
        style={{ ...classes.arrow, marginRight: "15px" }}
      />
    );

  return (
    <span className={className} onClick={props.onClick} style={classes.span}>
      {char}
    </span>
  );
}

const Testimonies = () => {
  const isMobile = useMediaQuery("(max-width:899px)");

  const theme = useTheme();
  const classes = useStyles(theme, isMobile);

  const { pathname } = useLocation();
  const componentName = "Testimonies";
  const translation = useTranslation(pathname, componentName);

  const { testimonies } = translation;

  return (
    <Box sx={classes.container}>
      <Box sx={classes.titleContainer}>
        {isMobile ? null : <div style={classes.line}></div>}
        <Typography sx={classes.title}>TESTIMONIOS</Typography>
      </Box>

      <Typography sx={classes.subtitle}>
        <span style={classes.span}>
          Conocé la experiencia de nuestros graduados
        </span>
      </Typography>

      {isMobile ? (
        <Slider
          swipeToSlide={true}
          slidesToShow={1}
          style={classes.slider}
          autoplay={true}
          autoplaySpeed={4000}
        >
          {testimonies.map(({ name, description, img, companyImg }) => {
            return (
              <div key={name}>
                <TestimonyCard
                  name={name}
                  description={description}
                  img={img}
                  company={companyImg}
                />
              </div>
            );
          })}
        </Slider>
      ) : (
        <div style={classes.sliderContainerDesktop}>
          <Slider
            nextArrow={<Arrow type="next" />}
            prevArrow={<Arrow type="prev" />}
            slidesToShow={3}
            style={classes.sliderDesktop}
            autoplay={true}
            autoplaySpeed={4000}
          >
            {testimonies.map(({ name, description, img, companyImg }) => {
              return (
                <div key={name}>
                  <TestimonyCard
                    name={name}
                    description={description}
                    img={img}
                    company={companyImg}
                  />
                </div>
              );
            })}
          </Slider>
        </div>
      )}
    </Box>
  );
};

export default Testimonies;
